import { makeEntityScaffold } from '@classpass/saga-tools';

const KEY = 'SAGA.API.PAGES';

export const pageContentByKey = makeEntityScaffold(`${KEY}.CONTENT`, (client, key) =>
  client.pages.getPageByKey(key).then(resp => resp.data)
);

export const pageIndexByKey = makeEntityScaffold(`${KEY}.INDEX`, (client, key) =>
  client.pages.getPageByKey(key).then(resp => resp.data)
);

export const venueTopTenPages = makeEntityScaffold(
  `${KEY}.VENUE_TOP_TEN`,
  (client, venueId) => client.pages.getVenueTopTenPages(venueId).then(resp => resp.data),
  { defaultKey: 1 }
);
